import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from './index'

// One example Redux Toolkit slice demonstrating the loading/error/data shape every other slice in
// a real app follows: a status flag, an optional error message, and the data itself.
export interface ExampleState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error?: string
  items: string[]
}

const initialState: ExampleState = {
  status: 'idle',
  items: [],
}

const exampleSlice = createSlice({
  name: 'example',
  initialState,
  reducers: {
    loadStarted: (state) => {
      state.status = 'loading'
      state.error = undefined
    },
    loadSucceeded: (state, action: PayloadAction<string[]>) => {
      state.status = 'succeeded'
      // Coerce defensively: `items` must always be an array so the render's `.map`/`.length` can
      // never throw, even if a caller hands this a non-array response.
      state.items = Array.isArray(action.payload) ? action.payload : []
      state.error = undefined
    },
    loadFailed: (state, action: PayloadAction<string>) => {
      state.status = 'failed'
      state.error = action.payload
    },
  },
})

export const { loadStarted, loadSucceeded, loadFailed } = exampleSlice.actions
export const selectExample = (state: RootState): ExampleState => state.example
export default exampleSlice.reducer
